<template>
    <a-drawer :title="title" width="400" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="生成数量" prop="count">
                <a-input-number v-model="field.count" :min="1" :max="100" />
            </a-form-model-item>
            <a-form-model-item label="有效时长（小时）" prop="hour">
                <a-input-number v-model="field.hour" :min="1" :max="360" suffix="小时" />
            </a-form-model-item>
            <a-form-model-item label="关联分组" prop="org">
                <a-select v-if="empMode === 'sel'" show-search v-model="field.org" :filter-option="false" :not-found-content="null" @search="doLoadOrg" :style="{ width: '70%' }">
                    <a-select-option v-for="item in orgs" :key="item.id" :value="item.id" :label="item.name">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            empMode: 'sel',
            orgs: [],

            field: {
                count: 100,
                hour: 6,
                org: ''
            },
            rules: {
                count: [{ type: 'number', required: true, message: '请选择分组', trigger: 'blur' }],
                hour: [{ type: 'number', required: true, message: '请选择分组', trigger: 'blur' }],
                org: [{ required: true, message: '请选择分组', trigger: 'blur' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
        }
        this.doLoadOrg()
    },
    methods: {
        doLoadOrg(name) {
            this.$http
                .get('/cts/ate/tester/org/query', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.orgs = result.datas
                })
        },
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/cts/ate/testing/code/mgr/build', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
